import { ReactNode } from 'react'
import { StyleProp, Text, TextStyle, View, ViewStyle } from 'react-native'
import { StyleSheet } from 'react-native-unistyles'

interface Props {
  children?: ReactNode
  style?: StyleProp<ViewStyle>
  title: string
  titleStyle?: StyleProp<TextStyle>
}

const Card = ({ children, title, titleStyle, style }: Props) => {
  return (
    <View style={[styles.surfaceCard, style]} testID={title}>
      <Text style={[styles.title, titleStyle]}>{title}</Text>
      {children}
    </View>
  )
}

const styles = StyleSheet.create((theme) => ({
  surfaceCard: {
    backgroundColor: theme.colors.surface,
    borderColor: theme.colors.cardBorder,
    borderRadius: theme.tokens.containerBorderRadius,
    borderWidth: 1,
    flex: 1,
    height: 'auto',
    minHeight: 'auto',
    padding: theme.tokens.spacing[4],
  },
  title: {
    color: theme.colors.secondary,
    fontSize: 24,
    lineHeight: 32,
    marginBottom: theme.tokens.spacing[4],
  },
}))

export default Card
